// Wrap what would be free-floating text in a span as unwrapped text can cause react errors when using Google Translate
export const SafeTranslateableText: React.FC = ({ children }) => {
  return <span>{children}</span>;
};
